// extracted by mini-css-extract-plugin
export default {"container":"order-ingredient-icon_container__gIrWw","imageContainer":"order-ingredient-icon_imageContainer__gkDEf","image":"order-ingredient-icon_image__CuYuk"};